export default "__VITE_ASSET__D9x8WoFQ__"